import { PhoneUpdateFiservType } from "../../../lib/api/models";
import { maskInput, INPUT_MASKS } from "../../../lib/formatting";
import StyledButton from "../../common/buttons/StyledButton";
import TextButton from "../../common/buttons/TextButton";
import BaseModal from "../../common/modals/BaseModal/BaseModal";
import ModalCloseButton from "../../common/modals/ModalCloseButton/ModalCloseButton";
import styles from "./UpdatePhoneNumberModal.module.css";

const strings = {
  title: "Confirm Phone Number Update",
  body: (
    phoneType: PhoneUpdateFiservType,
    prevNumber: string,
    newNumber: string,
  ) =>
    `The current phone number in the ${phoneType === "UPDATE_FDR_HOME" ? "Primary" : "Secondary"} is ${maskInput(INPUT_MASKS.phoneNumber, prevNumber)}, are you sure you want to update with ${maskInput(INPUT_MASKS.phoneNumber, newNumber)}?`,
  ok: "Ok",
  cancel: "Cancel",
};

type Props = {
  isOpen: boolean;
  phoneType: PhoneUpdateFiservType;
  prevNumber: string;
  newNumber: string;
  onSuccess: () => void;
  onRequestClose: () => void;
};

export default function UpdatePhoneNumberModal({
  isOpen,
  phoneType,
  prevNumber,
  newNumber,
  onSuccess,
  onRequestClose,
}: Props) {
  return (
    <BaseModal
      className={styles.modal}
      label={strings.title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div className={styles.header}>
        <div className={styles.title}>{strings.title}</div>
        <ModalCloseButton onClick={onRequestClose} />
      </div>
      <div className={styles.body}>
        {strings.body(phoneType, prevNumber, newNumber)}
      </div>
      <div className={styles.footer}>
        <StyledButton className={styles.okButton} onClick={onSuccess}>
          {strings.ok}
        </StyledButton>
        <TextButton onClick={onRequestClose}>{strings.cancel}</TextButton>
      </div>
    </BaseModal>
  );
}
